module.exports = __webpack_public_path__ + "img/conical_t2_washer.prt.7dfa962b.jpg";